module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker56-api.relevant-digital.com/"}};